import { Link } from "react-router-dom"

const Missing = () => {
    return (
        <article style={{ padding: "100px" }}>
            <h1>Our apologies&hellip;</h1>
            <p>Page Not Found</p>
            <nav>
                <Link to="/">Home</Link>
            </nav>
        </article>
    )
}

export default Missing
